const {
  REACT_APP_STOP_APP_URL,
  REACT_APP_STOP_APP_URL_BACK,
  REACT_APP_BASENAME,
  REACT_APP_FIREBASE_APP_ENV,
  REACT_APP_VAPID_KEY,
  REACT_APP_FIREBASE_API_KEY,
  REACT_APP_FIREBASE_AUTH_DOMAIN,
  REACT_APP_FIREBASE_PROJECT_ID,
  REACT_APP_FIREBASE_STORAGE_BUCKET,
  REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  REACT_APP_FIREBASE_APP_ID,
  REACT_APP_FIREBASE_MEASUREMENT_ID,
  REACT_APP_GOOGLE_MAPS_API_KEY
} = process.env;

const config = {
  URL: {
    STOP_APP_URL: window.ENV?.REACT_APP_STOP_APP_URL || REACT_APP_STOP_APP_URL,
    STOP_APP_URL_BACK: window.ENV?.REACT_APP_STOP_APP_URL_BACK || REACT_APP_STOP_APP_URL_BACK,
    BASENAME: window.ENV?.REACT_APP_BASENAME || REACT_APP_BASENAME,
  },
  FIREBASE: {
    REACT_APP_VAPID_KEY: REACT_APP_VAPID_KEY,
    REACT_APP_FIREBASE_APP_ENV: REACT_APP_FIREBASE_APP_ENV,
    REACT_APP_FIREBASE_API_KEY: REACT_APP_FIREBASE_API_KEY,
    REACT_APP_FIREBASE_AUTH_DOMAIN: REACT_APP_FIREBASE_AUTH_DOMAIN,
    REACT_APP_FIREBASE_PROJECT_ID: REACT_APP_FIREBASE_PROJECT_ID,
    REACT_APP_FIREBASE_STORAGE_BUCKET: REACT_APP_FIREBASE_STORAGE_BUCKET,
    REACT_APP_FIREBASE_MESSAGING_SENDER_ID: REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    REACT_APP_FIREBASE_APP_ID: REACT_APP_FIREBASE_APP_ID,
    REACT_APP_FIREBASE_MEASUREMENT_ID: REACT_APP_FIREBASE_MEASUREMENT_ID,
  },
  // AUTH: {
  //   USER: REACT_APP_N4_HEADER_AUTH_BASIC_USER,
  //   PASSWORD: REACT_APP_N4_HEADER_AUTH_BASIC_PW,
  //   CAPTCHA: {
  //     PROVIDER: (REACT_APP_N4_AUTH_CAPTCHA_PROVIDER || "none").toLowerCase(),
  //     SITEKEY: REACT_APP_N4_AUTH_CAPTCHA_SITEKEY || "",
  //   },
  // },
  GOOGLE_MAP: {
    GOOGLE_API_KEY: REACT_APP_GOOGLE_MAPS_API_KEY,
    PLACES: ["places", "geometry"],
  },
};

export default config;
